import script from "./GridLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./GridLayout.vue?vue&type=script&setup=true&lang=js"

import "./GridLayout.vue?vue&type=style&index=0&id=93516fb8&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-93516fb8"]])

export default __exports__